{
  "name": "silent-test",
  "_note": "§1 판정용: 소리 없이 촉각(시각)만으로 재질이 느껴지는지 확인. master=0. 다른 값은 기본과 동일.",
  "sound": { "master": 0 }
}
